// Only the unprefixed bare /search is indexable. URL keys, not recognised
// filters, result count or pagination state, determine parameterisation.
export function searchIsNoindex(pathname, search = "", hostname = "www.bookaclassic.com") {
  if (/^(?:www\.)?(?:driveshare\.com|bookaclassic\.us)$|^events\.driveshare\.com$/i.test(hostname)) return true;
  return pathname !== "/search" || [...new URLSearchParams(search).keys()].length > 0;
}
